import PropTypes from 'prop-types';
import React, {Component} from 'react';
import _get from "lodash/get";
import _isEmpty from 'lodash/isEmpty';
import {connect} from 'react-redux';
import {getLangCode, stringBundle} from '../../stringBundle';
import ContactEmailPref from './ContactEmailPref';
import ContactIVRPref from './ContactIVRPref';
import ContactSMSPref from './ContactSMSPref';
import {authUserType} from "../../helpers/propCheck";
import Modal from 'react-modal';
import {modalStyles} from '../common/ModalStyles';
import utils from "../../helpers/utils";
import {setModalSizeSpec} from "../../actions/modal";
import ModalFooter from '../../components/common/ModalFooter';
import CloseIcon from '../../components/common/CloseIcon';
import {accountContactPreferences} from "../../actions/account";

/* eslint-disable react/jsx-no-bind */

class ContactPrefs extends Component {

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    window.parent.postMessage({
      type: "GET_PARENT_WINDOW_SPEC",
      payload: document.body.scrollHeight
    }, window.REACT_APP_PARENT_HOST);
    Modal.setAppElement('body');
    this.localizedStringBundle = stringBundle(getLangCode());
  }


  componentDidMount() {
    utils.parentWindowResizeScroll();
    if (_isEmpty(_get(this.props.account, 'preferences', null))) {
      if (!_isEmpty(_get(this.props.auth, 'user.primaryMember.accountId', ''))) {
        const getPrefData = {method: 'get', origin: 'sms'};
        this.props.dispatch(accountContactPreferences(getPrefData, this.props.auth.user.primaryMember.accountId));
      }
    }
  }

  componentDidUpdate() {
    utils.parentWindowResizeScroll();
  }

  handleUpdateClick() {
    this.props.dispatch({
      type: 'SHOW_MODAL',
      modalType: 'EDIT_E_MAIL_ADDR_MODAL',
      modalProps: {
        data: {
          propMember: _get(this.props.auth, 'user.primaryMember'),
          contact: {
            email: _get(this.props.auth, 'user.primaryMember.primaryEmail'),
          },
        },
      },
    });
  }

  renderEmailSection(propMember, propConEmail, propConAlertEmail) {
    const currentUser = propMember;
    const isCaretaker = _get(currentUser, 'isCaretaker', false) === true;

    if (isCaretaker) {
      return (
        <ContactEmailPref
          propMember={propMember}
          propConAlertEmail={propConAlertEmail}
          propConEmail={propConEmail}
        />
      );
    } else if (!_isEmpty(propConAlertEmail)) {
      return (
        <div className="pt-13 border-b border-grey-lighter">
          <div className="text-base text-black pb-1">
            {this.localizedStringBundle.MANAGE_AP_CONTACT_EMAIL}
          </div>
          <div className="text-black text-sm font-semibold pb-4">
            <p>{propConAlertEmail}</p>
          </div>
        </div>
      );
    }
    return (
      <div className="row">
        <div className="col s12 m4 l4 label padding-left-0">
          {this.localizedStringBundle.MANAGE_AP_CONTACT_EMAIL}
        </div>
        <div className="col s12 m7 l7 input-field ">&nbsp;</div>
      </div>
    );
  }

  renderIVRSection(propPreferences) {
    if (!_isEmpty(propPreferences)) {
      return <ContactIVRPref propPreferences={propPreferences}/>;
    }
    return (
      <div className="">
        <div className="text-base text-black pb-1">
          {this.localizedStringBundle.MANAGE_AP_CONTACT_IVR}
        </div>
        <div className="text-grey text-sm pb-3">
          {this.localizedStringBundle.MANAGE_AP_CONTACT_IVR_TEXT}
          </div>
      </div>
    );
  }

  renderSMSSection(propMember, propPreferences) {
    if (!_isEmpty(propMember)) {
      return (
        <ContactSMSPref
          propMember={propMember}
          propPreferences={propPreferences}
        />
      );
    }
    return (
      <div className="flex">
        <div className="text-base text-black pb-1">
          {this.localizedStringBundle.MANAGE_AP_CONTACT_SMS}
        </div>
        <div className="text-grey text-sm pb-3">
          {this.localizedStringBundle.MANAGE_AP_CONTACT_SMS_TEXT}
        </div>
        <div className="flex-1 w-5/6 input-field h-12">&nbsp;</div>
      </div>
    );
  }

  renderContactPref() {
    let propPreferences;
    let isShowModal = this.checkModalState();

    if (isShowModal) {
      if (_isEmpty(this.props.auth) || _isEmpty(this.props.propModal)) {
        return null;
      }
      propPreferences = _get(this.props.propModal, 'modalProps.data.propPreferences', '');
    } else {
      if (_isEmpty(this.props.auth) || _isEmpty(_get(this.props.account, 'preferences', null))) {
        return null;
      }
      propPreferences = _get(this.props.account, 'preferences', '');
    }
    const data = _get(this.props.auth, 'user', '');
    let isFromPaypal = _get(this.props.auth, "isFromPaypal", null);
    let propMember = _get(data, 'primaryMember', '');
    let propConEmail = _get(data, 'primaryMember.primaryEmail', '');
    let propConAlertEmail = _get(data, 'primaryMember.primaryEmail.emailAddress', '');
    return (
      <div className="contact-form contact-prefs-interval">
        <div className="section-title font-semibold text-3xl text-grey text-center">
          {this.localizedStringBundle.MANAGE_AP_CONTACT_TITLE}
          </div>
        <div className="section-headertext-lg text-black text-center">
          {this.localizedStringBundle.MANAGE_AP_CONTACT_HEADER_TEXT2}
          </div>
        {this.renderEmailSection(propMember, propConEmail, propConAlertEmail)}
        {!isFromPaypal ? (
          <div>
            {this.renderIVRSection(propPreferences)}
            {this.renderSMSSection(propMember, propPreferences)}
            </div>) : null}
            </div>
    );
  }

  checkModalState() {
    if (this.props.propModal) {
      return this.props.propModal.modalType !== undefined && this.props.propModal.modalType !== null && this.props.propModal.modalType === 'ALERT_PREF_MODAL';
    } else {
      return false;
    }
  }

  handleClick() {
    window.parent.postMessage({type: "MODAL_OPENED", payload: false}, window.REACT_APP_PARENT_HOST);
    this.props.dispatch({type: 'HIDE_MODAL'});
    this.props.dispatch(setModalSizeSpec({content: {}}));
    utils.trackEventForManageAccount(this.localizedStringBundle.MANAGE_AP_CONTACT_TITLE, this.localizedStringBundle.MANAGE_ACCOUNT_CLOSE, true);
  }


  render() {
    if (!this.checkModalState()) {
      return (
        <div>
          {this.renderContactPref()}
        </div>
      );
    } else {
      if (_isEmpty(_get(this.props, 'propModal.modalSizeSpec.content', {}))) {
        return null
      }
      Object.assign(modalStyles.content, _get(this.props, 'propModal.modalSizeSpec.content', {}));
      return (
        <Modal
          isOpen={this.checkModalState()}
          style={modalStyles}
          contentLabel="Update Email"
          onRequestClose={this.handleClick}
        >
          <div className="flex flex-wrap">
            <div className="flex w-full h-20 py-6 px-4 md:px-8 justify-between border-b-1 border-grey-lightest">
              <div className="w-5/6">
                <p className="text-xl md:text-3xl font-bold uppercase">{this.localizedStringBundle.MANAGE_AP_CONTACT_TITLE}</p>
              </div>
              <div className="ma-modal-close w-1/6 text-right" onClick={this.handleClick}>
                <CloseIcon/>
              </div>
            </div>
            <div className="flex flex-wrap w-full border-b-1 border-grey-lighter">
              <div className="w-full md:w-2/3 px-4 md:px-8">
                {this.renderContactPref()}
              </div>
            </div>
            <div className="w-full">
              <ModalFooter/>
            </div>
          </div>
        </Modal>
      );
    }
  }
}

ContactPrefs.propTypes = {
  dispatch: PropTypes.func.isRequired,
  key: PropTypes.object,
  account: PropTypes.object,
  auth: authUserType,
  propModal: PropTypes.object,
};

function mapStateToProps(state) {
  const {auth, address, account, modal} = state;
  return {
    auth, address, account,
    propModal: modal
  }
}

export default connect(mapStateToProps)(ContactPrefs);


/* eslint-enable react/jsx-no-bind */



// WEBPACK FOOTER //
// ./src/containers/monitoring/ContactPrefs.js